import { CardCompletionTypeEnum } from 'appConsts';

export const getRemainingLessonsInfo = lessons => {
  const remainingLessons = [];
  lessons.forEach(lesson => {
    if (lesson.completionType === CardCompletionTypeEnum.optional) {
      return;
    }
    if (lesson.isGradable && lesson.performance.successStatus === 'NA') {
      remainingLessons.push(lesson);
    }
    if (!lesson.isGradable && lesson.performance.completionStatus !== 'COMPLETE') {
      remainingLessons.push(lesson);
    }
  });
  return remainingLessons;
};
